import axios from 'axios';

const API_BASE = import.meta.env.VITE_API_URL || '/api/v1';

const client = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use((config) => {
  const token = localStorage.getItem('navigator_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('navigator_token');
      // Guard against infinite reload loops: only reload once per session.
      // Without this, any page whose data fetch returns 401 (e.g. no/expired
      // token) reloads, remounts, fetches again, gets 401 again, forever.
      if (!sessionStorage.getItem('navigator_reload_guard')) {
        sessionStorage.setItem('navigator_reload_guard', '1');
        window.location.reload();
      }
    }
    return Promise.reject(error);
  }
);

export default client;

export const api = client;

export const authTelegram = async (initData: string) => {
  const res = await client.post('/auth/telegram', { init_data: initData });
  return res.data;
};

export const getMe = async () => {
  const res = await client.get('/me');
  return res.data;
};

export const getSearches = async () => {
  const res = await client.get('/searches');
  return res.data;
};

export const createSearch = async (data: any) => {
  const res = await client.post('/searches', data);
  return res.data;
};

export const startSearch = async (id: number) => {
  const res = await client.post(`/searches/${id}/start`);
  return res.data;
};

export const pauseSearch = async (id: number) => {
  const res = await client.post(`/searches/${id}/pause`);
  return res.data;
};

export const deleteSearch = async (id: number) => {
  const res = await client.delete(`/searches/${id}`);
  return res.data;
};

export const getPlans = async () => {
  const res = await client.get('/subscriptions/plans');
  return res.data;
};

export const getMySubscription = async () => {
  const res = await client.get('/subscriptions/my');
  return res.data;
};

export const createPayment = async (planId: number) => {
  const res = await client.post('/payments/create', { plan_id: planId });
  return res.data;
};
